<template>
  <v-container fluid>
    <!-- <v-breadcrumbs :items="items">
      <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
    </v-breadcrumbs> -->
    <div id="app ">
      <div style="display: flex; justify-content: space-between;">
        <!-- <v-col cols="11"> -->
        <Breadcrumb class="row justify-content-center mt-4" />
        <!-- </v-col> -->
        <span v-if="showLoader">
          <LoaderProgress></LoaderProgress>
        </span>
      </div>
    </div>
    <v-row class="mt-0 border-bottom">
      <v-col>
        <!-- <filterHeaderComp style="margin-right: 5px !important" /> -->
        <newcompoent
          style="margin-right: 5px !important"
          :filter_data="param"
        />
      </v-col>
    </v-row>
    <!-- <v-flex d-flex>
   <v-layout wrap>
       <v-flex md2 v-for="item in cardsData" :key="item.id">
           <v-card class="card-container">
                     <v-row align="center" class="text-center mbN-4">
            <v-col cols="12" sm="12" md="12" class="pr-0 pl-0" style="margin-top:-50px;">
              <div
                class="
                  transition-swing
                  text-subtitle-2
                  
                  text-gray
                "
              >
                {{ item.headerName }}
              </div>
              <div
                class="transition-swing  text-h4 font-weight-light text-success" style=" margin-top:22px;"
              >
                {{ item.contentName }}
              </div>
            </v-col>
          </v-row>
          </v-card>
       </v-flex>
   </v-layout>
</v-flex> -->
    <!-- <div 
            v-bind:key="gag.id" v-for="gag in cardsData"   >
      <v-row style="display: flex; flex-wrap: wrap">
              <v-col cols="6" sm="3" md="2">
                    <v-card class="oee-card oee-card-white mini-card" elevation="2">
          <v-row align="center" class="text-center mbN-4">
            <v-col cols="12" sm="12" md="12" class="pr-0 pl-0" style="margin-top:-50px;">
              <div
                class="
                  transition-swing
                  text-subtitle-2
                  
                  text-gray
                "
              >
                {{ gag.headerName }}
              </div>
              <div
                class="transition-swing  text-h4 font-weight-light text-success" style=" margin-top:22px;"
              >
                {{ gag.contentName }}
              </div>
            </v-col>
          </v-row>
        </v-card>    
</v-col>
        </v-row>
        </div> -->
    <v-row align="center">
      <v-col
        v-for="cardData in cardsData"
        :key="cardData.id"
        :cols="cardData.headerName !== 'Utilisation' ? 6 : 12"
        :sm="cardData.headerName !== 'Utilisation' ? 3 : 12"
        :md="cardData.headerName !== 'Utilisation' ? 2 : 12"
        :lg="cardData.headerName !== 'Utilisation' ? 2 : 12"
      >
        <div v-if="cardData.headerName !== 'Utilisation'">
          <v-card
            class="oee-card oee-card-white mini-card"
            elevation="2"
            width="100%"
            style="display: flex; flex-direction: column; justify-content: flex-start;"
          >
            <v-card-title
              class="
                  transition-swing
                  text-subtitle-2
                  text-gray
                "
              style="padding: 10px 0 25px 0;"
              >{{ cardData.headerName }}</v-card-title
            >
            <div>
              <h4
                style="font-size: 2rem; height: 100%;font-weight: 350;"
                :class="cardTextColor(cardData.contentName)"
              >
                {{ cardData.contentName }}
              </h4>
            </div>
          </v-card>
        </div>
      </v-col>
    </v-row>

    <v-row class="mb-3 mt-5 ">
      <v-col cols="12" sm="12" md="12">
        <v-card class="oee-card oee-card-white " elevation="2">
          <v-card-text class="">
            <v-row align="center" class="text-center">
              <v-col cols="12" sm="12" md="12" class="">
                <div id="chart">
                  <apexchart
                    ref="barChart"
                    type="bar"
                    height="200"
                    :options="cycletimechart.chartOptions"
                    :series="cycletimechart.series"
                    @click="redirect"
                  ></apexchart>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row class="mb-3 mt-5">
      <v-col cols="12" sm="12" md="12">
        <v-card class="oee-card oee-card-white " elevation="2">
          <v-card-text class="">
            <v-chip variant="elevated" color="primary">
              Utilisation (%) : {{ cardsData[6].contentName }}
            </v-chip>
            <v-row align="center" class="text-center">
              <v-col cols="12" sm="12" md="12" class="">
                <div id="chart">
                  <apexchart
                    ref="barChart1"
                    type="line"
                    height="200"
                    :options="cycletimechart1.chartOptions"
                    :series="cycletimechart1.series"
                  ></apexchart>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
// import filterHeaderComp from "../components/filterHeaderComp.vue";
import newcompoent from "../components/newFiltercomp.vue";
import Breadcrumb from "../components/breadcrumbs.vue";
import LoaderProgress from "../components/progressLoader";

import VueApexCharts from "vue-apexcharts";
// import constants from "../constants";
import axios from "axios";
import router from "../router";
export default {
  components: {
    newcompoent,
    apexchart: VueApexCharts,
    Breadcrumb,
    LoaderProgress,
  },

  data: (
    energy = "-",
    chartDates = [],
    // machineItems = [],
    chartPlots = [],
    chartPlots1 = [],
    chartDates1 = [],
    highAlertValue = 10
  ) => ({
    param: {
      machine: true,
      time_period: false,
      check: false,
      aggfunc: false,
      date: false,
      date_2: false,
      time: false,
      time2: false,
      select_1: 168,
    },
    showLoader: false,
    machine_id_Selected: "",

    items: [
      {
        text: "Home",
        disabled: false,
        href: "/",
      },
      {
        text: "Energy Monitoring Dashboard",
        disabled: false,
        href: "/EnergyMonitoring",
      },

      {
        text: "Machine DPIMM1",
        disabled: true,
      },
    ],
    energy: energy,

    cardsData: [],

    availiability: {
      id: "sanitisedData.id",
      // series: [70],
      chartOptions: {
        chart: {
          type: "radialBar",
        },
        plotOptions: {
          radialBar: {
            hollow: {
              size: "59%",
            },
            dataLabels: {
              textAnchor: "middle",
              name: {
                fontSize: "30px",
                offsetY: 14,
                color: "#FF9806",
              },
              value: {
                offsetY: -5,
                fontSize: "23px",
                color: "orange",
                formatter: function(val) {
                  console.log("formatter", val);
                  return val;
                },
                // fontSize: "23px",
                // show: false,
              },
            },
          },
        },
        fill: {
          colors: [
            function() {
              console.log("checking energyu", energy);
              if (energy < 50) {
                return "#ff0000";
              } else if (energy == 50 || energy <= 75) {
                return "#ffff00";
              } else {
                return "#29a329";
              }
            },
          ],
        },
        labels: [""],
      },
    },
    cycletimechart: {
      series: [
        {
          name: "Energy",
          data: chartPlots,
        },
      ],
      chartOptions: {
        chart: {
          type: "bar",
          height: 350,
          // events: {
          //   click: (event, chartContext) =>  {
          //     console.log("checking events in energy monitoring=>",event,"chartContext=>",chartContext,"this.machine_id_Selected=>",this.mac_id_Selected);
          //     router. push({ name: 'multiGauge',             params: { macId: this.mac_id_Selected }, })
          //   }
          // }
        },
        annotations: {
          yaxis: [
            {
              y: highAlertValue,
              borderColor: "#ff0000",
              borderWidth: 3,
              label: {
                borderColor: "#cc0066",
                style: {
                  color: "#fff",
                  width: 2,
                  background: "#cc0066",
                },
              },
            },
          ],
        },

        // legend: {
        //   position: "top",
        //           horizontalAlign: "center",
        //                                           showForSingleSeries: true,

        // },
        plotOptions: {
          bar: {
            horizontal: false,
            borderRadius: 0,
            radiusOnLastStackedBar: true,
            columnWidth: "70%",
            barHeight: "70%",
            distributed: false,
            rangeBarOverlap: true,
            rangeBarGroupRows: false,
            colors: {
              ranges: [
                {
                  from: 0,
                  to: 0,
                  color: undefined,
                },
              ],
              backgroundBarColors: [],
              backgroundBarOpacity: 1,
              backgroundBarRadius: 0,
            },
            dataLabels: {
              position: "top",
              maxItems: 100,
              hideOverflowingLabels: true,
            },
          },
        },
        dataLabels: {
          enabled: false,
        },
        // stroke: {
        //   show: true,
        //   width: 2,
        //   colors: ["transparent"],
        // },
        xaxis: {
          title: {
            text: "Time",
            align: "right",
            style: {
              color: "#484848",
              fontSize: "14px",
              fontWeight: "bold",
            },
          },
          categories: chartDates,
          labels: {
            style: {
              fontSize: "12px",
            },
          },
        },

        yaxis: {
          title: {
            text: "Energy(kWh)",
            fontSize: "14px",
          },
        },
        fill: {
          colors: ["#C9D6E9"],
        },
        tooltip: {
          y: {
            formatter: function(val) {
              return "" + val + " kWh";
            },
          },
        },
      },
    },
    cycletimechart1: {
      series: [
        {
          name: "Machine State",
          data: chartPlots1,
        },
      ],
      chartOptions: {
        chart: {
          type: "line",
          height: 350,
        },

        plotOptions: {},
        dataLabels: {
          enabled: false,
          colors: ["#C9D6E9"],
        },
        // stroke: {
        //   show: true,
        //   width: 2,
        //   colors: ["transparent"],
        // },
        stroke: {
          width: [2, 2, 2],
          curve: "stepline",
        },
        xaxis: {
          axisBorder: {
            show: true,
            color: "#78909C",
            height: 1,
            width: "100%",
            offsetX: 0,
            offsetY: 0,
          },
          title: {
            text: "Time",
            align: "right",
            style: {
              color: "#484848",
              fontSize: "14px",
              fontWeight: "bold",
            },
          },
          type: "datetime",
          datetimeUTC: false,
          labels: {
            datetimeUTC: false,
          },
          categories: chartDates1,
        },

        yaxis: {
          title: {
            text: "Machine state",
            fontSize: "14px",
          },
          tickAmount: 2,
          //              floating: true,
          // axisTicks: {
          //   show: false
          // },
          labels: {
            show: true,
            formatter: function(val) {
              //sujan(if value = 0,then it returns OFF and if 0 < value < 1 ,then it returns IDLE and
              // if value >=1 ,then it returns ON.)
              if (val == 0) {
                return "OFF";
              }
              if (val == 1) {
                return "IDLE";
              }
              if (val == 2) {
                return "ON";
              }
            }, // just formats date to hh:mm format
          },
          // axisBorder: {
          //   show: false
          // },
        },
        // fill: {
        //   colors: ["#C9D6E9"],
        // },
        tooltip: {
          x: {
            format: "dd MMM - HH : mm: ss",
          },
          y: {
            formatter: function(val) {
              //sujan(if value = 0,then it returns OFF and if 0 < value < 1 ,then it returns IDLE and
              // if value >=1 ,then it returns ON.)
              if (val == 0) {
                return "OFF";
              }
              if (val == 1) {
                return "IDLE";
              }
              if (val == 2) {
                return "ON";
              }
            },
          },
        },
      },
    },
  }),
  created() {
    this.setCardsData();

    console.log("Checking addition");
    this.$root.$on("route_first_option", (text) => {
      console.log(
        "checking  route_first_option text",
        text,
        typeof text,
        this.checkbox,
        typeof this.checkbox
      );
      // if (text) {
      //   ("checking whetehr text is satisfied");
      //   this.checkbox = true;
      // } else {
      //   this.checkbox = false;
      // }
    });

    console.log("checking set of card is", this.$route.params.macId);
    this.machine_id_Selected = this.$route.params.macId;
    console.log("checking after set of card", this.cardsData);
    // this.setMachineData();
    // console.log("Checking machine_items inside mounted",this.machineItems );

    this.energy = 0;
  },
  aftermounted() {},
  methods: {
    cardTextColor(data) {
      // let dataType = typeof data;
      let castingData = Number(data);

      if (castingData || data === "-") {
        return "blue-text";
      } else return "green-text";
    },
    getAnnotationData(value) {
      let originalValue = value;
      console.log("checking annotation values", value);
      if (value == "null") {
        value = -Infinity;
      } else {
        value = originalValue;
      }
      return value;
    },
    redirect() {
      router.push({
        name: "multiGauge",
        params: { macId: this.machine_id_Selected },
      });
    },
    setMachineData() {
      let config = {
        method: "get",
        url: `${this.$config.backend_url}/getMachineNames`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      };
      this.noteLastAPICallTime();
      axios(config)
        .then((response) => {
          console.log("response--getMachineNames", response.data);
          let machineData = response.data.data;
          // machineData.sort((first_machine, second_machine) => {
          //   return this.compareObjects(
          //     first_machine,
          //     second_machine,
          //     "machine_name"
          //   );
          // });
          console.log("cehcking machine dayta=>", machineData);
          // this.machineItems = machineData;
          // console.log("Checking machine_items", this.machineItems);
          // this.machineItems = response.data.data;
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            sessionStorage.clear();
            router.push("/login");
          } else {
            console.log("error--getMachineNames", error);
          }
        });
    },
    setCardsData: function() {
      this.cardsData = [
        { id: "1", headerName: "Total kWh Cost", contentName: "-" },

        { id: "2", headerName: "Machine State", contentName: "-" },
        { id: "3", headerName: "Uptime", contentName: "-" },
        { id: "4", headerName: "Total Today", contentName: "-" },
        { id: "5", headerName: "Total", contentName: "-" },
        { id: "6", headerName: "Daily avg", contentName: "-" },
        { id: "7", headerName: "Utilisation", contentName: "-" },
      ];
    },
    getTimeInHours: (mins) => {
      let hours = Math.floor(mins / 60);
      let minutes = mins % 60;
      return `${hours}h${minutes}m`;
    },

    searchNew: function(machine_id, startDate, endDate) {
      this.start_date = startDate;
      this.end_date = endDate;
      console.log(
        "start and end date while calling searchNew",
        this.start_date,
        this.end_date,
        machine_id
      );
      this.machine_id_Selected = machine_id;
      console.log(
        "machine select",
        this.machine_id_Selected,
        "Done to say",
        machine_id
      );
      let config = {};
      this.showLoader = true;

      if (this.start_date == "") {
        console.log("checking if energymonitoring");
        config = {
          method: "get",
          url: `${this.$config.backend_url}/getEnergyMonitoringData?machine=${machine_id}`,
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        };
      } else {
        //   if (sessionStorage.start_date!==null || sessionStorage.start_date!=='' &&
        // sessionStorage.end_date!==null || sessionStorage.end_date!=='' ){
        //   // sujan(added a condition if start date and end date is undifined)
        //   if (sessionStorage.end_date!==undefined && sessionStorage.start_date!==undefined){
        //     config = {
        //     method: "get",
        //     url: `${this.$config.backend_url}/getEnergyMonitoringData?machine=${machine_id}&startdate=${sessionStorage.start_date}&enddate=${sessionStorage.end_date}`,
        //     headers: {
        //       Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        //     },
        //   };
        //   }
        //     // params = `?startdate=${start}&enddate=${end}`;

        // }
        // else{
        config = {
          method: "get",
          url: `${this.$config.backend_url}/getEnergyMonitoringData?machine=${machine_id}&startdate=${this.start_date}&enddate=${this.end_date}`,
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
          // };
        };
      }
      this.noteLastAPICallTime();
      axios(config)
        .then((response) => {
          let responseData = response.data.data;
          console.log("Checking response", response.data);
          // if (responseData == undefined)
          // {
          //             console.log("the energy response is: ", response.data);

          //           console.log("the energy response is: ",JSON.parse( response.data));

          // }

          if (responseData != undefined) {
            this.cardsData.forEach((card) => {
              if (card.headerName === "Machine State") {
                card.contentName = responseData.status || "-";
              } else if (card.headerName === "Uptime") {
                // card.contentName = `${responseData.total_up_time}mins` || "-";
                card.contentName =
                  responseData.total_up_time &&
                  responseData.total_up_time !== null
                    ? this.getTimeInHours(responseData.total_up_time)
                    : "-";
              } else if (card.headerName === "Total kWh Cost") {
                // card.contentName = `${responseData.total_up_time}mins` || "-";
                card.contentName =
                  responseData.total_price && responseData.total_price !== null
                    ? `${responseData.total_price}`
                    : "-";
              } else if (card.headerName === "Total Today") {
                card.contentName =
                  responseData.today_kwh && responseData.today_kwh !== null
                    ? `${responseData.today_kwh}`
                    : "-";
              } else if (card.headerName === "Total") {
                card.contentName =
                  responseData.total_kwh && responseData.total_kwh !== null
                    ? `${responseData.total_kwh}`
                    : "-";
              } else if (card.headerName === "Daily avg") {
                card.contentName =
                  responseData.daily_avg_kwh &&
                  responseData.daily_avg_kwh !== null
                    ? `${responseData.daily_avg_kwh}`
                    : "-";
              } else if (card.headerName === "Utilisation") {
                card.contentName =
                  responseData.runtime_percentage &&
                  responseData.runtime_percentage !== null
                    ? `${responseData.runtime_percentage}`
                    : 0;
              }
            });
          }
          let energyThresoldLimit = responseData.energy_consumption_limit || 1;
          this.energy = responseData.today_kwh || [0];
          this.availiability.series = [this.energy] || [0];
          this.availiability.machine_id = this.machine_id_Selected;
          this.cycletimechart.chartOptions.annotations.yaxis[0].y =
            energyThresoldLimit || 1;
          this.availiability.labels = this.energy.toString() || "0";
          if (
            responseData.daily_total_kwh ||
            responseData.daily_total_kwh.length
          ) {
            let plots = [];
            let dates = [];

            responseData.daily_total_kwh.forEach((reading) => {
              dates.push(reading.kwh_date);
              plots.push(reading.avg_reading);
            });
            let time = [];
            let value = [];
            responseData.machine_state.forEach((reading) => {
              time.push(reading.start_time * 1000 || reading.start_time);
              value.push(reading.parameter_value);
            });
            console.log("the dates are", time);
            console.log("the plots are", value);
            this.chartDates = dates;
            this.chartPlots = plots;
            this.showLoader = false;
            this.chartDates1 = time;
            this.chartPlots1 = value;
            console.log("the refs", this.$refs);
            this.$refs.barChart.updateOptions({
              xaxis: {
                categories: this.chartDates,
              },
            });
            this.$refs.barChart.updateSeries(
              [
                {
                  data: this.chartPlots,
                },
              ],
              false,
              true
            );
            // this.$refs.barChart.updateOptions();
            this.$refs.barChart1.updateOptions({
              xaxis: {
                categories: this.chartDates1,
              },
            });
            this.$refs.barChart1.updateSeries(
              [
                {
                  data: this.chartPlots1,
                },
              ],
              false,
              true
            );
          }
        })
        .catch((error) => {
          this.showLoader = false;
          if (error.response && error.response.status === 401) {
            sessionStorage.clear();
            router.push("/login");
          } else {
            console.log("axios error", error.message);
          }
        });
    },
    intervalFetchData: function(machine_id, startDate, endDate) {
      console.log("being called on load");
      let self = this;
      console.log("in energy with: ", machine_id, startDate, endDate);
      console.log(
        "inside interval fetchdata with data",
        machine_id,
        startDate,
        endDate
      );
      if (!machine_id) {
        console.log("mac id is null");
        machine_id = this.machine_id_Selected;
      }
      this.machine_id_Selected = machine_id;
      this.start_date = startDate;
      this.end_date = endDate;
      console.log("machine id", machine_id);
      console.log(
        "1 selected start date",
        this.start_date,
        "selected end date",
        this.end_date
      );
      self.searchNew(this.machine_id_Selected, this.start_date, this.end_date);
    },
  },
};
</script>
<style scoped>
.green-text {
  color: #76b141;
}
.blue-text {
  color: #0c479d;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  margin-top: 60px;
}
</style>
